import {createReducer} from '../utility'




export const applicationTypes = createReducer({},{
    "APPLICATION_TYPES_RECEIVED"(state, {data}){
        if(data){
            return {
                ...state,
                types: data
            }
        }else{
            return{
                ...state
            }
        }
    } 
})